<template>
  <div
    class="company-benefit job-benefit"
    @mouseover="showDescription = true"
    @mouseout="showDescription = false"
  >
    <div
      class="company-benefit__front d-block d-md-flex text-center text-md-left flex-column justify-center align-md-center"
    >
      <div class="company-benefit__custom-icon">
        <div
          v-if="showAsMaskImage"
          class="company-benefit__custom-icon"
          :style="
            'mask-image: url(' +
            baseUrl +
            benefit.imagePath +
            '); -webkit-mask-image: url(' +
            baseUrl +
            benefit.imagePath +
            '); -webkit-mask-size: contain; mask-size: contain; width: 100px; height: 100px; background-color: ' +
            benefitsColor
          "
        ></div>

        <img
          v-else
          :src="baseUrl + benefit.imagePath"
          alt=""
          aria-hidden="true"
        />
      </div>

      <div v-if="localize(benefit.name)" class="company-benefit__label mb-4">
        {{ localize(benefit.name) }}
      </div>

      <template v-if="localize(benefit.description)">
        <div class="text-center" v-html="localize(benefit.description)"></div>
      </template>

      <!-- <div class="company-benefit__overlay" v-if="hasDescription">
        <div v-html="localize(benefit.itemDescription)"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    benefit: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    showDescription: false
  }),

  computed: {
    ...mapState('companyModule', {
      baseUrl: 'baseUrl',
      benefitsColor: 'benefitsColor'
    }),

    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    }),

    showAsMaskImage() {
      return (
        this.benefit.imagePath &&
        this.benefit.imagePath.toLowerCase().trim().endsWith('.svg')
      );
    }
  }
};
</script>

<style scoped>
.company-benefit {
  position: relative;
  overflow: hidden;
}

.company-benefit__overlay {
  font-size: var(--font-size-sm);
  background-color: var(--accent);
  color: var(--primary-complement);
  position: absolute;
  top: 0;
  left: -1000px;
  right: 100%;
  bottom: 0;
  -moz-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
  -webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
  display: flex;
  align-items: center;
  font-weight: bold;
}

.company-benefit:hover .company-benefit__overlay {
  left: 0;
  right: 0;
}
</style>
